import { Route, Redirect } from "react-router-dom";
//import { pathArray } from "../utils/utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function CandidatePrivateRoute({ component: Component, ...rest }) {
  const candidateAuth = useSelector((state) => state.candidateAuth);
  const token = useSelector((state) => state.auth.token);
  console.log(candidateAuth);
  const location = useLocation();
  let currentPosition = candidateAuth.indexOf(location.pathname);
  console.log("this is the current position", currentPosition);
  //const redirectToPath=(currentPosition !== -1)?newPathArray[currentPosition]:candidateAuth[candidateAuth.length-1]
  const redirectToPath = candidateAuth[0]
    ? candidateAuth[candidateAuth.length - 1]
    : "/";
  //   if(!candidateAuth.length<5){

  //   }

  return (
    <Route
      {...rest}
      render={({ props }) =>
        candidateAuth.includes(location.pathname) && token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: token ? redirectToPath : "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default CandidatePrivateRoute;
